import { State } from '../../types';

export const northDakota: State = {
  name: 'North Dakota',
  abbreviation: 'ND',
  terms: [
    {
      word: 'Aneta',
      phonetic: 'ah-NET-ah',
      // audioUrl: '/audio/aneta.mp3',
      description: 'A town located about 60 miles southwest of Grand Forks, often mispronounced as "ah-NEAT-ah."'
    },
    {
      word: 'Arnegard',
      phonetic: 'ARE-nee-guard',
      // audioUrl: '/audio/arnegard.mp3',
      description: 'A town in McKenzie County, sometimes mispronounced due to its unique spelling.'
    },
    {
      word: 'Bucyrus',
      phonetic: 'BYOO-sigh-rus',
      // audioUrl: '/audio/bucyrus.mp3',
      description: 'A small town in Adams County, often mispronounced as "buck-ee-russ."'
    },
    {
      word: 'Kulm',
      phonetic: 'kahlm',
      // audioUrl: '/audio/kulm.mp3',
      description: 'A town in LaMoure County, pronounced similarly to "calm."'
    },
    {
      word: 'Mekinock',
      phonetic: 'MECK-in-ock',
      // audioUrl: '/audio/mekinock.mp3',
      description: 'A town just north of the Grand Forks Air Force Base, sometimes referred to as "Me-Kin-ock."'
    },
    {
      word: 'Minot',
      phonetic: 'MYE-not',
      // audioUrl: '/audio/minot.mp3',
      description: 'A city in Ward County, often mispronounced as "My-not."'
    },
    {
      word: 'Minto',
      phonetic: 'MIN-toh',
      // audioUrl: '/audio/minto.mp3',
      description: 'A town located just south of Grafton, commonly mispronounced by out-of-staters.'
    },
    {
      word: 'Palermo',
      phonetic: 'PAL-er-mow',
      // audioUrl: '/audio/palermo.mp3',
      description: 'A small community in Mountrail County, pronounced differently from its Italian counterpart.'
    },
    {
      word: 'Williston',
      phonetic: 'WILL-iss-tun',
      audioUrl: '/audio/williston.mp3',
      description: 'City in western North Dakota'
    },
    {
      word: 'Wyndmere',
      phonetic: 'WIND-meer',
      // audioUrl: '/audio/wyndmere.mp3',
      description: 'A town in Richland County, often mispronounced due to its spelling.'
    },
    {
      word: 'Ypsilanti',
      phonetic: 'IP-sil-AN-tee',
      // audioUrl: '/audio/ypsilanti.mp3',
      description: 'A community in Stutsman County, with a name that poses pronunciation challenges.'
    }
  ]
};